import { render, staticRenderFns } from "./qualification_average_by_project_type.vue?vue&type=template&id=45701e86&"
import script from "./qualification_average_by_project_type.vue?vue&type=script&lang=js&"
export * from "./qualification_average_by_project_type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45701e86')) {
      api.createRecord('45701e86', component.options)
    } else {
      api.reload('45701e86', component.options)
    }
    module.hot.accept("./qualification_average_by_project_type.vue?vue&type=template&id=45701e86&", function () {
      api.rerender('45701e86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/metrics/qualification_average_by_project_type.vue"
export default component.exports